import { HiddenInput, Label, Box } from './styled';
import { CheckboxFieldProps } from './types';

const CheckboxField = ({ checked, onChange }: CheckboxFieldProps) => {
  return (
    <Label>
      <HiddenInput type="checkbox" checked={checked} onChange={onChange} />
      <Box />
    </Label>
  );
};

export default CheckboxField;
